import React from 'react';
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import { ChildCare, FamilyRestroom, School } from '@mui/icons-material';

// Modal único de "Escolha uma opção" na etapa 'escolha' — substitui os antigos
// DialogOpcoesJovem (18-24) e DialogOpcoesAdulto (25+). As duas primeiras
// opções valem pra qualquer idade 18+; a 3ª ("Matrícula na Mocidade") só
// aparece pra quem tem entre 18 e 24 anos.
const DialogOpcoesEscolha = ({
  showDialogOpcoes,
  setShowDialogOpcoes,
  isResponsavel,
  idade,
  usuarioLogado,
  initialValues,
  formikRef,
  setUser,
  setUserHasPassword,
  setIsUserVerified,
  setShowIJMForm,
  setShowIJMFormMenor,
  setPrecisaResponsavel,
  setEscolhaCadastro,
  setEtapaAtual,
  setShowDialogSelecionarMenor,
  cadastrarNovoMenor,
}) => (
  <Dialog
    open={showDialogOpcoes}
    onClose={() => setShowDialogOpcoes(false)}
    maxWidth='sm'
    fullWidth
  >
    <DialogTitle>Escolha uma opção</DialogTitle>
    <DialogContent>
      <List>
        {isResponsavel && (
          <ListItemButton
            onClick={() => {
              setShowDialogOpcoes(false);
              setShowDialogSelecionarMenor(true);
            }}
            sx={{
              mb: 2,
              border: 1,
              borderColor: 'divider',
              borderRadius: 1,
              '&:hover': {
                borderColor: 'primary.main',
                bgcolor: 'primary.50',
              },
            }}
          >
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: 'secondary.main' }}>
                <FamilyRestroom />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='Matricular um menor já cadastrado'
              secondary='Escolher um menor vinculado a mim'
            />
          </ListItemButton>
        )}

        <ListItemButton
          onClick={() => {
            setShowDialogOpcoes(false);
            cadastrarNovoMenor();
          }}
          sx={{
            mb: 2,
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            '&:hover': { borderColor: 'primary.main', bgcolor: 'primary.50' },
          }}
        >
          <ListItemAvatar>
            <Avatar sx={{ bgcolor: 'success.main' }}>
              <ChildCare />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Cadastrar e matricular novo menor'
            secondary='Registrar uma nova criança/jovem'
          />
        </ListItemButton>

        {idade >= 18 && idade <= 24 && (
          <ListItemButton
            onClick={() => {
              setUser(usuarioLogado);
              setUserHasPassword(true);
              setIsUserVerified(true);
              setShowIJMForm(true);
              setShowIJMFormMenor(false);
              setPrecisaResponsavel(false);
              setEscolhaCadastro('mocidade');
              setShowDialogOpcoes(false);
              setEtapaAtual('formulario');

              setTimeout(() => {
                if (formikRef.current) {
                  formikRef.current.setValues({
                    ...initialValues,
                    nome: usuarioLogado.nome || '',
                    data_nascimento: usuarioLogado.data_nascimento || '',
                    cpf: usuarioLogado.cpf || '',
                    rg: usuarioLogado.rg || '',
                    email: usuarioLogado.email || '',
                    email_confirmacao: usuarioLogado.email || '',
                    celular: usuarioLogado.celular || '05511',
                    celular_confirmacao: usuarioLogado.celular || '',
                    telefone: usuarioLogado.telefone || '05511',
                    pais: usuarioLogado.pais || 'BR',
                    CEP: usuarioLogado.CEP || '',
                    endereco: usuarioLogado.endereco || '',
                    numero: usuarioLogado.numero || '',
                    complemento: usuarioLogado.complemento || '',
                    bairro: usuarioLogado.bairro || '',
                    cidade: usuarioLogado.cidade || '',
                    uf: usuarioLogado.uf || '',
                    turmas_id: '',
                  });
                }
              }, 100);
            }}
            sx={{
              mb: 2,
              border: 1,
              borderColor: 'divider',
              borderRadius: 1,
              '&:hover': { borderColor: 'primary.main', bgcolor: 'primary.50' },
            }}
          >
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: 'primary.main' }}>
                <School />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='Matrícula na Mocidade'
              secondary='Fazer matrícula para mim mesmo'
            />
          </ListItemButton>
        )}
      </List>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => setShowDialogOpcoes(false)}>Cancelar</Button>
    </DialogActions>
  </Dialog>
);

export default DialogOpcoesEscolha;
